import React from 'react'
import {FieldArray, FormikProps} from 'formik'
import {useIntl} from 'react-intl'
import TextInput from '../../widgets/components/Input/TextInput'
import {useAuth} from '../../auth'
import {DocumentFormValues} from '../core/_models'
import {getTodayDate} from '../../../core/_util'
import {useThemeMode} from '../../../../_metronic/partials'

const Signatories = ({
  formik,
  signatoryRole,
  isEdited,
}: {
  formik: FormikProps<DocumentFormValues>
  signatoryRole: string | undefined
  isEdited: boolean
}) => {
  const {formatMessage} = useIntl()
  const {currentUser} = useAuth()
  const {mode} = useThemeMode()

  return (
    <div >
      <FieldArray
        name='signatories'
        render={(arrayHelpers) => {
          return (
            <div>
              {arrayHelpers.form.values.signatories.map((signatory: any, index: number) => {
                return (
                  <div className={`mb-3 ${mode === 'dark' ? 'bg-clr1e1' : 'bg-f9f'} p-5 mb-4`}>
                    <div className='mb-2'>{signatory.role}</div>
                    <div key={index} className='d-md-flex align-items-start'>
                      <TextInput
                        isDisabled={isEdited && signatory.role !== signatoryRole}
                        fieldName={`signatories.${index}.name`}
                        fieldType={'text'}
                        formik={formik}
                        placeholder={formatMessage({id: 'Enter Signatory Name'})}
                        label={formatMessage({id: 'Signatory Name'})}
                        isStarRequired={true}
                        isTooltipForModal={true}
                        toolTipText='Please mention the full name of the Signatory.'
                        isMargin='w-32 w-full-mobile mb-5 mb-md-0'
                        isWidthNotRequired
                      />
                      <TextInput
                        isDisabled={isEdited && signatory.role !== signatoryRole}
                        fieldName={`signatories.${index}.email`}
                        fieldType={'email'}
                        formik={formik}
                        placeholder={formatMessage({id: 'Enter Signatory Email'})}
                        isTooltipForModal={true}
                        toolTipText='Please mention the valid email id of the Signatory'
                        label={formatMessage({id: 'Signatory Email'})}
                        isStarRequired={true}
                        isMargin='w-32 w-full-mobile mb-5 mb-md-0'
                        isWidthNotRequired
                      />
                      <TextInput
                        isDisabled={isEdited && signatory.role !== signatoryRole}
                        fieldName={`signatories.${index}.dueDate`}
                        fieldType={'date'}
                        formik={formik}
                        isTooltipForModal={true}
                        toolTipText='Please mention the date by which this signatory has to sign this document i.e. the due date.'
                        placeholder={formatMessage({id: 'Enter Due Date'})}
                        label={formatMessage({id: 'Due Date'})}
                        isStarRequired={true}
                        isMargin='w-32 w-full-mobile mb-5 mb-md-0'
                        isWidthNotRequired
                        isDateField={true}
                      />
                    </div>
                  </div>
                )
              })}
              <div className='d-flex justify-content-end'>
                <button
                  type='button'
                  disabled={formik.values.signatories.length > 1}
                  className='btn btn-outline-primary'
                  onClick={() => {
                    formik.setFieldValue(`signatories[${formik.values.signatories.length - 1}]`, {
                      name: `${currentUser?.firstName} ${currentUser?.lastName}`,
                      email: currentUser?.email,
                      role: formik.values.signatories[formik.values.signatories.length - 1].role,
                      dueDate: getTodayDate(),
                    })
                  }}
                >
                  {formatMessage({id: 'I am the only signer'})}
                </button>
              </div>
            </div>
          )
        }}
      />
    </div>
  )
}

export default Signatories
